<template>
	<card layout="grid" tag="section">
		<template #default>
			<loading v-if="loading"></loading>
			<div v-else class="widget-container">
				<div class="partner-info" v-for="p in partners" :key="p.ID">
					<div @click="OnClick(p)">
						<user-picture :user="p" link size="large"></user-picture>
						<div class="is-flex is-flex-direction-column mt-2">
							<div>
								<h3>{{ p.firstName }} {{ p.lastName }}</h3>
								<div>{{ p.location }}</div>
							</div>
							<div class="mt-4">
								<div>
									<span class="has-text-grey">Total billings:&nbsp;</span>
									<strong>{{ currencyFormat.format(p.totalBillingsUsd) }}</strong>
								</div>
								<div>
									<span class="has-text-grey">Teaming value:&nbsp;</span>
									<strong>{{ currencyFormat.format(p.teamingValueUsd) }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <o-button outlined>View full list</o-button> -->
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { useRouter } from "vue-router";
	import { currencyFormat } from "@/services/utils";
	export default {
		props: {
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const $http = inject("$http");
			const $error = inject("$error");
			const $router = useRouter();

			const partners = ref([]);
			const loading = ref(true);

			const OnClick = (partner) => {
				if (props.link) {
					$router.push({ name: "_partnerProfile", params: { Id: props.user.Id } });
				} else {
					context.emit("click");
				}
			};

			const GetData = async () => {
				try {
					loading.value = true;
					const response = await $http.post("/api/v2/widget/topPartners", {
						filter: props.filters
					});
					partners.value = response.data;
					loading.value = false;
				} catch (err) {
					$error("Could not retrieve partner list.");
					loading.value = false;
				}
			};

			onMounted(() => {
				GetData();
			});

			return {
				currencyFormat,
				partners,
				loading,
				OnClick
			};
		}
	};
</script>
